import { configureStore, Middleware } from "@reduxjs/toolkit";
import config from "@ey/voltron-config";
import { apiMiddleware } from "../middlewares/api";
import authenticationMiddleware from "@ey/voltron-core/authentication";

export const store = configureStore({
  reducer: {},
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      authenticationMiddleware(config.ad) as Middleware,
      apiMiddleware(config.ad) as Middleware
    );
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
